import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import Panes from '../../../sharedLegacy/components/PanesComponent/PanesComponent'
import WebinarInfoPane from '../../../sharedLegacy/components/WebinarInfoPaneComponent/WebinarInfoPaneComponent'
import WebinarUserInfoPane from '../../../sharedLegacy/components/WebinarUserInfoPaneComponent/WebinarUserInfoPaneComponent'
import { useInterval } from '../../../sharedLegacy/hooks'
import { useAudienceAppState } from '../../providers/AudienceAppStateProvider'
import usePreconnect from '../../hooks/usePreconnect'

import AudienceFoyerLoader from './AudienceFoyerLoaderComponent'

import './AudienceFoyerComponent.scss'

const getWebinarStatus = (isDraft, liveStatus) => {
  if (!isDraft) return liveStatus
  return 'draft'
}

const AudienceFoyerPanes = {
  WebinarInfo: 0,
  UserInfo: 1,
}

/**
 * AudienceFoyerComponent
 */
const AudienceFoyerComponent = ({ renderOptions, onError }) => {
  const { liveId, liveToken } = useAudienceAppState()
  const { load, webinar } = usePreconnect(liveId, liveToken, onError)
  const isFoyerDataLoaded = !!webinar

  useEffect(() => {
    load()
  }, [load])

  useInterval(() => {
    load()
  }, 5000)

  const numberOfPanes = Object.keys(AudienceFoyerPanes).length

  const title = webinar?.name || ''
  const isDraft = webinar?.draft_p
  const liveStatus = webinar?.live_status
  const status = getWebinarStatus(isDraft, liveStatus) || 'draft'
  const description = webinar?.description_html || ''
  const speakers = webinar?.speakers || []
  const liveDate = new Date(webinar?.live_date)
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
  const name = window.localStorage?.comment_name ?? ''
  const link = webinar?.link

  return (
    <div className="audience-foyer">
      <AudienceFoyerLoader isLoading={!isFoyerDataLoaded}>
        <div className="audience-foyer-panes">
          <Panes
            numberOfPanes={numberOfPanes}
            direction="row"
            renderPane={(index) => {
              if (index === AudienceFoyerPanes.WebinarInfo) {
                return (
                  <WebinarInfoPane
                    title={title}
                    description={description}
                    status={status}
                    liveDate={liveDate}
                    speakers={speakers}
                  />
                )
              }

              if (index === AudienceFoyerPanes.UserInfo) {
                return (
                  <WebinarUserInfoPane name={name}>
                    {renderOptions && renderOptions(name, link)}
                  </WebinarUserInfoPane>
                )
              }

              return null
            }}
          />
        </div>
      </AudienceFoyerLoader>
    </div>
  )
}

AudienceFoyerComponent.propTypes = {
  onError: PropTypes.func.isRequired,
  renderOptions: PropTypes.func,
}

// eslint-disable-next-line import-x/no-default-export
export default AudienceFoyerComponent
